var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 26.7C17.0008 26.7 20.3583 25.3093 22.8338 22.8338C25.3093 20.3583 26.7 17.0008 26.7 13.5C26.7 9.99913 25.3093 6.64166 22.8338 4.16618C20.3583 1.6907 17.0008 0.299988 13.5 0.299988C9.99913 0.299988 6.64166 1.6907 4.16618 4.16618C1.6907 6.64166 0.299988 9.99913 0.299988 13.5C0.299988 17.0008 1.6907 20.3583 4.16618 22.8338C6.64166 25.3093 9.99913 26.7 13.5 26.7V26.7ZM19.6165 11.3665C19.9171 11.0553 20.0834 10.6386 20.0796 10.2059C20.0759 9.7733 19.9024 9.35946 19.5964 9.05354C19.2905 8.74761 18.8767 8.57408 18.444 8.57033C18.0114 8.56657 17.5946 8.73288 17.2834 9.03344L11.85 14.4669L9.71654 12.3334C9.40534 12.0329 8.98855 11.8666 8.55593 11.8703C8.1233 11.8741 7.70946 12.0476 7.40354 12.3535C7.09761 12.6595 6.92408 13.0733 6.92033 13.5059C6.91657 13.9386 7.08288 14.3553 7.38344 14.6665L10.6834 17.9665C10.9929 18.2759 11.4125 18.4496 11.85 18.4496C12.2875 18.4496 12.7071 18.2759 13.0165 17.9665L19.6165 11.3665V11.3665Z",
    fill: "#627D98"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9ef13d4945dbde0832b93c1b706a8c34.svg";
export { ForwardRef as ReactComponent };